<template>
  <div>
    <div
      v-for="(attachment, index) in attachments"
      :key="index"
      class="d-flex align-center justify-start rounded border px-4 py-3 mb-2"
    >
      <v-col cols="auto" class="pr-2">
        <v-img width="24" contain :src="$asset(`img/icons/${icon}.svg`)" />
      </v-col>
      <v-col class="row_content">
        <div class="text-truncate">
          <template v-if="attachment.url">
            <a @click.stop="openAttachment(attachment.url)">{{ attachment.name }}</a>
          </template>
          <template v-else>
            {{ attachment.name }}
          </template>
        </div>
      </v-col>
      <v-col cols="auto" class="cursor-pointer ml-auto" @click="$emit('clickRemove', attachment)">
        <v-img width="24" contain :src="$asset('img/icons/bin.svg')" />
      </v-col>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AttachmentRow',
  props: {
    attachments: {
      type: Array,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  },
  methods: {
    openAttachment(url) {
      this.$emit('attachment_downloaded');
      this.newTab(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.row_content {
  overflow: hidden;
}
</style>
